import * as angular from 'angular';
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import { apsCommands } from "../../shared/dto/aps.commands";
import HttpServiceName, { HttpService } from "../http/http.service";
import { Endpoints } from "../../shared/config/constant.module";

export interface CommoditiesService {
  get(plantId: string): angular.IPromise<apsViewModels.CommodityItem[]>;
  getCommodityPercentages(plantId: string): angular.IPromise<apsViewModels.CommodityPercentageItem[]>;
  add(command: apsCommands.AddCommodity): angular.IPromise<any>;
  update(command: apsCommands.UpdateCommodity): angular.IPromise<any>;
  updateCommodityPercentage(command: apsCommands.UpdateCommodityPercentage): angular.IPromise<any>;
  remove(command: apsCommands.RemoveCommodity): angular.IPromise<any>;
  removeCommodityPercentage(command: apsCommands.RemoveCommodityPercentage): angular.IPromise<any>;
}

class CommoditiesSvc implements CommoditiesService {
  private httpService: HttpService;

  constructor(httpService: HttpService) {
    this.httpService = httpService;
  }

  get(plantId: string): angular.IPromise<apsViewModels.CommodityItem[]> {
    return this.httpService.get<apsViewModels.CommodityItem[]>(Endpoints.COMMODITIES, { plantId: plantId });
  }

  getCommodityPercentages(plantId: string): angular.IPromise<apsViewModels.CommodityPercentageItem[]> {
    return this.httpService.get<apsViewModels.CommodityPercentageItem[]>(Endpoints.COMMODITYPERCENTAGES, { plantId: plantId });
  }
  add(command: apsCommands.AddCommodity): angular.IPromise<any> {
    return this.httpService.post(Endpoints.COMMODITIES, command);
  }

  update(command: apsCommands.UpdateCommodity): angular.IPromise<any> {
    return this.httpService.put(Endpoints.COMMODITIES, command);
  }

  updateCommodityPercentage(command: apsCommands.UpdateCommodityPercentage): angular.IPromise<any> {
    return this.httpService.put(Endpoints.COMMODITYPERCENTAGES, command);
  }
  remove(command: apsCommands.RemoveCommodity): angular.IPromise<any> {
    return this.httpService.delete(Endpoints.COMMODITIES + '/' + command.id,
      { plantId: command.plantId });
  }
  removeCommodityPercentage(command: apsCommands.RemoveCommodityPercentage): angular.IPromise<any> {
    return this.httpService.delete(Endpoints.COMMODITYPERCENTAGES + '/' + command.id,{ plantId: command.plantId });
  }
}

export default angular
  .module('aps.services.commodities', [HttpServiceName])
  .service('commoditiesService', CommoditiesSvc)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/batches/commodities.service.ts